import {ProtocolCommand} from '../../../service-model/protocol-command.interface';
import {SHELL_PROTOCOL_OPERATIONS_NS} from '../shell-protocol-namespace.const';

export class UnsubscribePriceBars implements ProtocolCommand {
  constructor(
    public readonly ticker: string,
    public readonly timeframe: string,
    public readonly subscriptionKey: string
  ) {
  }

  getOperationName(): string {
    return `${SHELL_PROTOCOL_OPERATIONS_NS}.UnsubscribePriceBars`;
  }
}
